import * as React from "react"

function TopShopperQuestions(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 350" {...props}>
      <style>
        {
          ".top-shopper-questions_st3{fill:#fff}.top-shopper-questions_st4{fill:#e9ecef}.top-shopper-questions_st5{fill:#c1c6cb}.top-shopper-questions_st8{fill:none;stroke:#fff;stroke-miterlimit:10}"
        }
      </style>
      <g id="top-shopper-questions_Guides_and_Back">
        <path
          d="M30 29.5c31.5-25.2 74.9 23.8 168.8 35.8C333.4 82.6 378-1 465.9 30.8c81.2 29.3 142.6 136.4 116.2 198.7-16.3 38.6-75.7 51.4-193.8 75.6-145.4 29.8-219.3 43.8-276.9 3.9-51.5-35.6-70-93.6-81.2-128.4-7-21.8-38.6-120.5-.2-151.1z"
          fill="#7c8bdf"
        />
        <path className="top-shopper-questions_st3" d="M50 50h500v250H50z" />
      </g>
      <g id="top-shopper-questions_Page_Content">
        <path
          className="top-shopper-questions_st3"
          d="M86.2 92.5c-2 0-3.7-1.7-3.7-3.7V72.2c0-2 1.7-3.7 3.7-3.7h178.6c2 0 3.7 1.7 3.7 3.7v16.6c0 2-1.7 3.7-3.7 3.7H86.2z"
        />
        <path
          className="top-shopper-questions_st4"
          d="M264.8 69c1.8 0 3.2 1.4 3.2 3.2v16.6c0 1.8-1.4 3.2-3.2 3.2H86.2c-1.8 0-3.2-1.4-3.2-3.2V72.2c0-1.8 1.4-3.2 3.2-3.2h178.6m0-1H86.2c-2.3 0-4.2 1.9-4.2 4.2v16.6c0 2.3 1.9 4.2 4.2 4.2h178.6c2.3 0 4.2-1.9 4.2-4.2V72.2c0-2.3-1.9-4.2-4.2-4.2zM86 281.5c-1.9 0-3.5-1.6-3.5-3.5V107c0-1.9 1.6-3.5 3.5-3.5h428.1c1.9 0 3.5 1.6 3.5 3.5v171c0 1.9-1.6 3.5-3.5 3.5H86z"
        />
        <path
          className="top-shopper-questions_st4"
          d="M514.2 104c1.7 0 3 1.3 3 3v171c0 1.7-1.3 3-3 3H86c-1.7 0-3-1.3-3-3V107c0-1.7 1.3-3 3-3h428.2m0-1H86c-2.2 0-4 1.8-4 4v171c0 2.2 1.8 4 4 4h428.1c2.2 0 4-1.8 4-4V107c.1-2.2-1.7-4-3.9-4z"
        />
        <path
          className="top-shopper-questions_st5"
          d="M92.3 111.7H157v8.6H92.3zM92.3 126.7H504v8.6H92.3zM92.3 141.7H374v8.6H92.3zM132.3 161.7H181v8.6h-48.7zM110.3 161.7H122v8.6h-11.7zM132.3 175.7H199v8.6h-66.7zM110.3 175.7H122v8.6h-11.7zM132.3 189.7H309v8.6H132.3zM110.3 189.7H122v8.6h-11.7zM132.3 203.7H259v8.6H132.3zM110.3 203.7H122v8.6h-11.7zM132.3 217.7H242v8.6H132.3zM110.3 217.7H122v8.6h-11.7zM132.3 231.7H321v8.6H132.3zM110.3 231.7H122v8.6h-11.7zM132.3 245.7H263v8.6H132.3zM110.3 245.7H122v8.6h-11.7zM132.3 259.7H214v8.6h-81.7zM110.3 259.7H122v8.6h-11.7zM132.3 273.7H221v8.3h-88.7zM110.3 273.7H122v8.3h-11.7zM92.3 75.7H176v8.6H92.3z"
        />
        <path
          d="M295 93h-22c-2.2 0-4-1.8-4-4V72c0-2.2 1.8-4 4-4h22c2.2 0 4 1.8 4 4v17c0 2.2-1.8 4-4 4z"
          fill="#1eca8a"
        />
        <path
          d="M326.8 82.9l-1.6-.9c.2-.9.2-1.8 0-2.6l1.6-.9c.2-.1.3-.3.2-.5-.4-1.3-1.1-2.5-2.1-3.6-.1-.2-.4-.2-.6-.1l-1.6.9c-.7-.6-1.4-1-2.3-1.3V72c0-.2-.1-.4-.4-.4-1.4-.3-2.8-.3-4.1 0-.2 0-.4.2-.4.4v1.8c-.8.3-1.6.7-2.3 1.3l-1.6-.9c-.2-.1-.4-.1-.6.1-.9 1-1.6 2.2-2.1 3.6-.1.2 0 .4.2.5l1.6.9c-.2.9-.2 1.8 0 2.6l-1.6.9c-.2.1-.3.3-.2.5.4 1.3 1.1 2.5 2.1 3.6.1.2.4.2.6.1l1.6-.9c.7.6 1.4 1 2.3 1.3v1.8c0 .2.1.4.4.4 1.4.3 2.8.3 4.1 0 .2 0 .4-.2.4-.4v-1.8c.8-.3 1.6-.7 2.3-1.3l1.6.9c.2.1.4.1.6-.1.9-1 1.6-2.2 2.1-3.6.1-.1 0-.3-.2-.4zm-8.7.8c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z"
          fill="#00aeef"
        />
        <path
          className="top-shopper-questions_st8"
          d="M107.1 158.2h376.4M107.1 173.2h376.4M107.1 187.2h376.4M107.1 201.2h376.4M107.1 215.2h376.4M107.1 229.2h376.4M107.1 243.2h376.4M107.1 257.2h376.4M107.1 271.2h376.4"
        />
      </g>
    </svg>
  )
}

export default TopShopperQuestions
